// extracted by mini-css-extract-plugin
export default {"status":"ProjectSettings_status__UgOWq","status__error":"ProjectSettings_status__error__h4Hwn","value":"ProjectSettings_value__Nkars"};